var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3333 11C3.3333 11.221 3.2455 11.433 3.0892 11.5893C2.9329 11.7456 2.7209 11.8334 2.4999 11.8334H1.6666C1.4456 11.8334 1.2336 11.7456 1.0773 11.5893C0.920998 11.433 0.833298 11.221 0.833298 11V1C0.833298 0.779002 0.920998 0.567002 1.0773 0.410802C1.2336 0.254502 1.4456 0.166702 1.6666 0.166702H2.4999C2.7209 0.166702 2.9329 0.254502 3.0892 0.410802C3.2455 0.567002 3.3333 0.779002 3.3333 1V11ZM9.1666 11C9.1666 11.221 9.0788 11.433 8.9225 11.5893C8.7662 11.7456 8.5543 11.8334 8.3333 11.8334H7.4999C7.2789 11.8334 7.0669 11.7456 6.9107 11.5893C6.7544 11.433 6.6666 11.221 6.6666 11V1C6.6666 0.779002 6.7544 0.567002 6.9107 0.410802C7.0669 0.254502 7.2789 0.166702 7.4999 0.166702H8.3333C8.5543 0.166702 8.7662 0.254502 8.9225 0.410802C9.0788 0.567002 9.1666 0.779002 9.1666 1V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.9887da611e69be9e6ebdd5aa3888650f.svg";
export { ForwardRef as ReactComponent };